import { showPopup, hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
export const specsPopupDispatcher = dispatch => ({
  onImageClick: shownImageIndex => {
    dispatch(showPopup({
      popup: 'teeImage',
      shownImageIndex
    }));
  },
  onClose: () => dispatch(hidePopup())
});